import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer bg-secondary flex flex-col justify-center text-white" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Privacy policy")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", {
      class: "mt-8 mb-2 px-8 md:px-0 text-center",
      innerHTML: _ctx.$t('footer.contact')
    }, null, 8, _hoisted_2),
    _createVNode(_component_router_link, {
      to: "/privacy",
      class: "text-sm underline text-center mb-4"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}